import doc                    from 'decorators/doc';
import model                  from 'decorators/model';
import { Timestampable }      from 'helpers/traits';
import { Blamable }           from 'helpers/traits';
import InvoicePrivateApiModel from 'modelx/models/abstracts/InvoicePrivateApiModel';

@model.cacheDuration()
@model.staticLabel('Statut')
@model.urnResource('accounting_import_status')
@doc.path('/accounting_import_statuses/{?id}')
export default class AccountingImportStatusModel extends Blamable(Timestampable(InvoicePrivateApiModel)) {
	public _filters: ModelFiltersExtended<{
		'reference': InvoiceAccountingImportStatusReference;
	}> = {};

	public _sorts: ModelSortsExtended<{
		'id': string;
		'label': string;
	}> = {};

	@doc.string declare label: string;
	@doc.string declare reference: InvoiceAccountingImportStatusReference;

	public get color() {
		switch (this.reference) {
			case 'error':
				return 'red';
			case 'done':
				return 'green';
		}
	}
}
